import { Module } from 'vuex'
import { RootState } from '@/store/index'
import { mutations } from '@/store/modules/news/mutations'
import { INewsState, initialState } from '@/store/modules/news/state'

export * from '@/store/modules/news/state'

export const store: Module<INewsState, RootState> = {
  state: initialState,
  mutations
}
